module.exports = __webpack_public_path__ + "media/images/record2-1bd049119a998f7c1a8902fa9eba1451.svg";